import { useEffect } from 'react'
import { useLCPDetector } from 'utils/hooks/useLCPDetector'
import {
  GOOGLE_TAG_MANAGER_KEY,
  GTM_DEFAULT_DATA_LAYER,
} from 'config/constants'

/**
 * 延遲載入第三方 script（目前只先延遲 GTM），等 LCP 完成後再執行
 */
const ThirdPartyScriptsLoader = () => {
  const lcpDetected = useLCPDetector()

  useEffect(() => {
    if (!lcpDetected) return

    // 載入 GTM
    const loadGTM = () => {
      window[GTM_DEFAULT_DATA_LAYER] = window[GTM_DEFAULT_DATA_LAYER] || []
      window[GTM_DEFAULT_DATA_LAYER].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      })

      const script = document.createElement('script')
      script.async = true
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_MANAGER_KEY}&l=${GTM_DEFAULT_DATA_LAYER}`
      document.head.appendChild(script)
    }

    loadGTM()
  }, [lcpDetected])

  return null
}

export default ThirdPartyScriptsLoader
